export const ErrorPage = ({ error, onClick }) => (
  <div className="error-wrapper">
    <div>
      Encountering error... <br />
      {error} <br />
      <button className="logout-button" onClick={onClick}>Sign in</button>
    </div>
  </div>
)
